import {AdminMessage} from '#/Conversations';
import {Stats} from '#/Stats';

export interface AdminState {
    previous: null | string;
    next: null | string;
    popMessages: AdminMessage[];
    privateMessages: AdminMessage[];
    newPrivateMessages: AdminMessage[];
    stats: Stats;
}

export const state: AdminState = {
    previous: null,
    next: null,
    popMessages: [],
    privateMessages: [],
    newPrivateMessages: [],
    stats: {
        adminMessageNumber: [],
        messageNumber: [],
        publishedAdvertsNumber: [],
        userMessageNumber: [],
        userNumber: [],
    },
};
